// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

declare var require: any;

export const environment = {
	adyenClientKey: "test_WXZRA27YMVFWTMY2HVMP3BAKJMGICBZO",
	approvedVenueKeys: [7166, 6380, 6383, 4246, 8995, 9730, 11841, 15413, 11841, 16048],
	debugVenueKeys: [7166, 6383, 11841, 11004, 15339, 15007],
	focusCaDealerKey: "6rtZ3iXZcEeUtppgXgQlzQ",
	googleMapsApiKey: "AIzaSyDxNVXjshBWSC3KratHgTjiuplbsLPlOzI",
	licenseKey: "4cd38ee4-faa5-4321-9d7e-38b3bf3c7868",
	myFocusAuthKey: "TtzPVQln6xGe-AP3OLyEiQ",
	production: false,
	userJwtKey: "2f6071eb-81fb-49fb-924f-8eb3917f2c03",
	quickbooksDealerclientId: "ABt3xCwPyr1yVKTwaXwNBBwm131o1KSYmvn5W97E2oHtFbe69u",
	quickbooksDealerclientSecret: "T0Dc64OwGgJhd8Woxe8EsnRrOsmRtK67aDg8I25w",
	quickbooksVenueclientId: "ABt3xCwPyr1yVKTwaXwNBBwm131o1KSYmvn5W97E2oHtFbe69u",
	quickbooksVenueclientSecret: "T0Dc64OwGgJhd8Woxe8EsnRrOsmRtK67aDg8I25w",
	version: require("../../version.json").version + "-dev",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
